import { all, } from "redux-saga/effects";

import { clienteController } from "../modulos/cliente/cliente.controll";
import { fornecedorController } from "../modulos/fornecedor/forn.controll";
import { funcionarioController } from "../modulos/funcionario/funcionario.controll";
import { meioPagController } from "../modulos/meioPag/meiopg.controll";
import { itemController } from "../modulos/item/item.controll";
import { configController } from "../modulos/config/config.controll";
import { tipoMovController } from "../modulos/tipoMov/tipomov.controll";
import { movController } from "../modulos/movimentacoes/mov.controll";
import { canalDistController } from "../modulos/canalDist/canalDist.controll";
import { contasController } from "../modulos/contas/contas.controll";
import { estoqueController } from "../modulos/estoque/estoque.controll";
import { tabelaPrecoController } from "../modulos/settings/tabelaPreco/tabpreco.controll";
import { convenioController } from "../modulos/settings/convenio/convenio.controll";
import { galeriaController } from "../modulos/galeria/galeria.controll";

export default function* rootSaga():any {
    return yield all([
        ...clienteController.actionEffects,
        ...fornecedorController.actionEffects,
        ...funcionarioController.actionEffects,
        ...meioPagController.actionEffects,
        ...itemController.actionEffects,
        ...configController.actionEffects,
        ...tipoMovController.actionEffects,
        ...movController.actionEffects,
        ...canalDistController.actionEffects,
        ...contasController.actionEffects,
        ...estoqueController.actionEffects,
        ...tabelaPrecoController.actionEffects,
        ...convenioController.actionEffects,
        ...galeriaController.actionEffects
    ])
}
